function getBrowserTimeZone(): string | null {
  if (typeof Intl === 'undefined') {
    return null
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return timeZone?.trim() || null
}

/** SWR key + API path for geo/timezone-based default currency (?country= / ?timezone= in dev). */
export function getDefaultCurrencyRequestUrl(): string {
  if (typeof window === 'undefined') {
    return '/api/invoices/default-currency'
  }
  const params = new URLSearchParams()
  const country = new URLSearchParams(window.location.search).get('country')
  if (country?.trim()) {
    params.set('country', country.trim())
  }
  const timeZone = getBrowserTimeZone()
  if (timeZone) {
    params.set('timezone', timeZone)
  }
  const query = params.toString()
  if (!query) {
    return '/api/invoices/default-currency'
  }
  return `/api/invoices/default-currency?${query}`
}
